// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__p82Qz","requiredMarker":"Label_requiredMarker__6z5tw","useFade-fadeIn":"Label_useFade-fadeIn__vlQfr","useFade-fadeOut":"Label_useFade-fadeOut__z6p0J"};